(function messagesScript($, Drupal) {
  Drupal.behaviors.menu_block_main_navigation = {
    attach(context) {
      var $menuToggle = $('.menu-toggle');
      var $mainMenu = $('.header .main-navigation .main-navigation__menu');

      function mainMenu() {

        if (window.matchMedia("(min-width: 960px)").matches) {
          $mainMenu.show();
        } else {
          $mainMenu.hide();
        }

        $menuToggle.unbind().click(function() {
          $mainMenu.slideToggle();
        });

      }
      mainMenu();

      var $subMenuToggle = $(".header .sub-menu-item-toggle");
      var $subMenuItem = $('.header .menu-item--has-sub-menu');
      function subMenu() {
        $(this)
          .toggleClass("sub-menu-item-toggle--closed")
          .toggleClass("sub-menu-item-toggle--opened");
        $(this)
          .siblings(".menu")
          .slideToggle();
        $(this)
          .parent()
          .toggleClass("menu-item--closed");
        $(this)
          .parent()
          .toggleClass("menu-item--opened");
      }

      function subMenuItemToggle() {
        $(this).find($subMenuToggle)
          .toggleClass("sub-menu-item-toggle--closed")
          .toggleClass("sub-menu-item-toggle--opened");
        $(this)
          .find(".menu")
          .slideToggle();
        $(this)
          .toggleClass("menu-item--closed");
        $(this)
          .toggleClass("menu-item--opened");
      }

      function toggleSubMenu() {
        if (window.matchMedia("(min-width: 960px)").matches) {
          $subMenuToggle.unbind().click(subMenu);
          $subMenuItem.unbind().hover(subMenuItemToggle);
        } else {
          $subMenuToggle.unbind().click(subMenu);
        }
      }
      toggleSubMenu();
      

      $(window).resize(function() {
        mainMenu();
        toggleSubMenu();
      });
    },
  };
}(jQuery, Drupal));
